import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./ContentBankItemList.module.css"
import AddNewItemBtn from "./AddNewItemBtn";
import ContentBankItem from '../ContentBankItem/ContentBankItem';
import { ContentBankTabsEnum } from "../../../../models/ContentBankTabsEnum";
import ToastMessage from "../../../UI/ToastMessage";
import { contentBankApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { ClassificationEnum } from "../../../../models/ClassificationContentBankEnum";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import Loader from '../../../UI/Loader';

const ContentBankItemList = ({ contentBankItemList, setContentBankItemList, setContentBankItem, warrperData, dataAPI, handleChange, selectedMaterial, setSelectedMaterial }) => {

    const options = ["יוצר", "שימושים", "תאריך", "שם"];
    const texts = useSelector((state) => state.translate.texts);
    const direction = useSelector((state) => state.translate.direction)
    const user = useSelector((state) => state.auth.user);
    const { applicationId } = useSelector(state => state.application);

    const dispatch = useDispatch();

    const [sortBy, setSortBy] = useState(texts.sort);
    const [showSortSelect, setShowSortSelect] = useState(false);

    const handleSelect = e => {
        setSortBy(e.target.innerText);
        setShowSortSelect(false);
        handleChange('sort', e.target.innerText);
    }

    const getFoundedResult = () => {
        if (contentBankItemList) {
            return `${contentBankItemList.length} ${texts.MaterialsFound}`;
        }
        if (warrperData.myMaterialList?.props?.myMaterialList?.filteredData) {
            return `${warrperData.myMaterialList.props.myMaterialList.filteredData.length} ${texts.MaterialsFound}`;
        }
        return texts.dataLoading;
    }

    function handleCopy(e, id, showPopup, close) {
        e.stopPropagation()
        const data = {
            id: id,
            refObjectType: ObjectTypeNamesEnum.Application,
            refObjectId: applicationId
        }

        contentBankApi.contentBankImportRefObjectPost({ contentBankImportRefObjectInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: '', error: error, statusCode: response?.statusCode, message: "ContentBankDuplicate " + error.message, level: 2, component: "ContentBankItemList", line: 53 }))
            }
            else {
                showPopup(<ToastMessage text={texts.MessageContentSuccessCopyContentBank} color="green" close={close} />)
            }
        })
    }

    function handleEditName(e, contentBankId, newName, setIsEditName) {
        e.stopPropagation()
        if (newName && newName !== '') {
            const data = {
                id: contentBankId,
                name: newName
            }
            contentBankApi.contentBankUpdatePost({ "contentBankUpdateInput": data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.projectsUpdateError, error: error, statusCode: response?.statusCode, message: "contentBankUpdatePost " + error.message, level: 2, component: "ContentBankItemList", line: 74 }))
                } else {
                    setIsEditName(false)
                    let newContentBankItemList = [...contentBankItemList];
                    let newData = newContentBankItemList.find(cb => cb.id === contentBankId)
                    newData.name = newName;
                    setContentBankItemList(newContentBankItemList)
                }
            })
        }
    }

    function handleDelete(e, id, showPopup, close, setMessagePopup) {
        e.stopPropagation()
        contentBankApi.contentBankDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentDeleteProjectStatus, error: error, statusCode: response?.statusCode, message: "contentBankDeleteIdPost " + error.message, level: 2, component: "ContentBankItemList", line: 54 }))
            }
            else {
                showPopup(<ToastMessage text={texts.MessageContentSuccessDeleteContentBankStatus} color="green" close={close} />)
                setContentBankItemList(contentBankItemList.filter(cb => cb.id !== id))
            }
        })
        setMessagePopup(false)
    }

    const forceDownload = (blob, filename) => {
        var a = document.createElement('a');
        a.download = filename;
        a.href = blob;
        // For Firefox https://stackoverflow.com/a/32226068
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    // Current blob size limit is around 500MB for browsers
    const handleDownload = (e, material) => {
        e.stopPropagation()
        fetch(material.url, {
            headers: new Headers({
                'Origin': window.location.origin
            }),
            mode: 'cors'
        }).then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                forceDownload(blobUrl, material.name);
            }).catch(e => console.error(e));
    }

    return (
        <div className={`${classes[direction]} ${classes.ContentBankListContainer}`}>
            <div className={classes.SelectWarrper}>
                <h3 className={classes.ListLength}>{getFoundedResult()}</h3>
                {/* <div className={`${classes.SortSelect} ${showSortSelect ? classes.ShowSortSelect : ''}`}>
                    <div className={classes.SortSelectSelected} onClick={() => setShowSortSelect(!showSortSelect)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowSortSelect(!showSortSelect))}>
                        <div>{sortBy}</div>
                        <img src={selectArrowIcon} className={`${classes.selectArrowIcon} ${showSortSelect ? classes.selectArrowIconOpen : ''}`} />
                    </div>
                    {showSortSelect && <div className={classes.SortSelectDropDown}>
                        {options.map(item => <div key={item} className={classes.SortSelectOption} onClick={handleSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleSelect)}>{texts.by} {item}</div>)}
                    </div>}
                </div> */}
            </div>
            <div className={classes.ContentBankListWarrper}>
                {!contentBankItemList && !warrperData.myMaterialList?.props?.myMaterialList?.filteredData && <Loader />}
                <div className={`${classes.ContentBankList} ${warrperData?.fromPopup ? classes.ContentBankListInPopup : ''}`}>

                    {/* check if the user is on nationalRepository tab or if the user on the headquartersRepository tab and is Supervisor */}
                    {(dataAPI.tabs === ContentBankTabsEnum.nationalRepository || (user.isSupervisor && dataAPI.tabs === ContentBankTabsEnum.headquartersRepository)) && !warrperData?.fromPopup &&
                        <AddNewItemBtn upload={warrperData.handleUpload} text={warrperData.uploadText} addItem={warrperData.addItem} setAddItem={warrperData.setAddItem} contentBankItemList={contentBankItemList} />}

                    {contentBankItemList && [].concat(contentBankItemList).sort((a, b) => a.lastCreatedHistoryDate < b.lastCreatedHistoryDate ? 1 : -1).map((c, i) =>
                        <div key={i} className={`${classes.ContentBankItemWrapper} ${selectedMaterial && selectedMaterial === c.id ? classes.Select : ``} `}>
                            <ContentBankItem contentBankItem={c} showProjectPopup={!warrperData?.fromPopup} setContentBankItem={setContentBankItem} handleEditName={handleEditName} handleCopy={dataAPI.classificationId === ClassificationEnum.project && handleCopy} handleDelete={handleDelete} handleDownload={dataAPI.classificationId === ClassificationEnum.auxiliary && handleDownload} />
                        </div>
                    )}

                    {warrperData.myMaterialList && warrperData.myMaterialList}
                </div>
            </div>
        </div>

    )
}

export default ContentBankItemList;